module.exports = __webpack_public_path__ + "img/bombas_centrifugas.e4ddd8c0.jpg";